<img
    class="d-block w-100 listing-img"
    src="{{ listing.image }}"
    alt="First slide"
/>
<div class="carousel-caption d-md-block">
    <div class="listing-details">
        <h5>$468,000</h5>
        <p>
            {{ listing.address + ", " + listing.city + ", " + listing.state }}
        </p>
        <p class="room_details">2 bds | 2.5 bths | 1,8250 sqft</p>
    </div>
</div>
